import { Box, Typography, Container, Divider, SvgIcon } from "@mui/material";
import { Link } from "react-router-dom";
import { KeyboardBackspace } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
// import img54 from "../../assets/newimg/logo.png";
import img54 from "../../assets/ocesha_images/ocesha_logo.png";
import { useState, useEffect } from "react";

import { object, string, TypeOf } from "zod";
import { useSubscribeNewsMutation } from "../../redux/api/authApi";
import { toast } from "react-toastify";
import { useForm, FormProvider, SubmitHandler } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

const newsSubscribeform = object({
  email: string()
    .min(1, "Email address is required")
    .email("Email address is invalid"),
  status: string(),
});

export type NewsSubscriptionForm = TypeOf<typeof newsSubscribeform>;
const Creatormonetization = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate("/codegenie/smart_contracts");
  };
  const [subscribeVal, setSubscribeVal] = useState<NewsSubscriptionForm>({
    email: "",
    status: "",
  });
  const [newsSubsctiptionMutation, newsSubscriptionState] =
    useSubscribeNewsMutation();

  const methods = useForm<NewsSubscriptionForm>({
    resolver: zodResolver(newsSubscribeform),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmitHandler: SubmitHandler<NewsSubscriptionForm> = (values) => {
    newsSubsctiptionMutation(values);
  };

  const handleSubscribeNews = () => {
    newsSubsctiptionMutation(subscribeVal)
      .unwrap()
      .then((response) => {
        console.log("news subscription=>", response);
        const status = response.status;

        console.log(status);
        if (status === "success") {
          toast.success(response.message);
          setSubscribeVal({
            email: "",
            status: "",
          });
        }
      })
      .catch((error) => {
        toast.error(error?.data?.detail ?? "Something went wrong!");
        console.error("Error sending query:", error);
      });
  };
  return (
    <>
      <Container maxWidth="lg">
        <nav className="navbar navbar-expand-md">
          <div className="container-fluid">
            <a className="navbar-brand" href={process.env.REACT_APP_LOGOUT_DOMAIN || "https://ocesha.ai"}>
              {/* <img src="./img/logo.png" alt="" /> */}
              <img src={img54} alt="" style={{ height: "70px" }} />
              {/* <img src={logo} alt="" /> */}
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarScroll"
              aria-controls="navbarScroll"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="">
                <i className="bi bi-list text-white" />
              </span>
            </button>

            <div className="collapse navbar-collapse" id="navbarScroll">
              <ul className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll gap-4">
                {/* ms-md-5 */}
                <li className="nav-item">
                  <a
                    className="nav-link nav_active"
                    style={{ color: "#4ba5eb", fontWeight: 800 }}
                    href="/"
                  >
                    Home
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link nav_simple"
                    href="https://ocesha-inc.getrewardful.com/signup?_gl=1*1lh53li*_gcl_au*MTc0Njg4MTI3Ni4xNzQ2NzMwMTA0*_ga*MTY2NzI5OTM0OC4xNzQ2NzMwMTA0*_ga_YJYFH7ZS27*czE3NDY3MzAxMDMkbzEkZzEkdDE3NDY3MzEwNjckajM3JGwwJGgw"
                  >
                    Affiliate
                  </a>
                </li>
              </ul>

              <div className="d-flex gap-4" role="search">
                <button
                  className="button_leniar px-3"
                  type="submit"
                  onClick={() => {
                    navigate("/signup");
                  }}
                >
                  Try Now
                </button>
                <button
                  className="btn btn-outline-primary px-3"
                  onClick={() => {
                    navigate("/signin");
                  }}
                >
                  Sign in
                </button>
              </div>
            </div>
          </div>
        </nav>
        <Box py={5}>
          <Typography
            variant="h2"
            color="text.secondary"
            fontWeight={600}
            textAlign="justify"
            mb={10}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              OceSha.ai Creator Monetization Terms
            </div>
          </Typography>
          <Typography>
            Last Updated: March 1, 2026
            <br />
            <br />
            These Creator Monetization Terms (“Creator Terms”) govern your use of OceSha’s monetization features, including course sales, Digital Twin instruction, creator pages, marketplace listings, and payment integrations (collectively, “Monetization Services”).            <br />
            By enabling monetization features or connecting a payment processor, you agree to this Payment Addendum. <br /><br />
            These Creator Terms form part of the OceSha Terms of Service and Payment Processing Addendum. <br /><br />
            By enabling monetization features, you agree to these Creator Terms.
          </Typography>
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            1. Creator Status       
          </Typography>
          <Typography>
           When you activate monetization features, you become a “Creator” on the OceSha platform. <br /><br />
           As a Creator, you:

           <Box component="ul">
              <Box component="li">Publish courses or educational products</Box>
              <Box component="li">Set pricing and refund policies</Box>
              <Box component="li">Interact with students or customers</Box>
              <Box component="li">Receive revenue through a third-party payment processor</Box>
            </Box>
            OceSha provides infrastructure only. <br /><br />
            OceSha is not:
            <Box component="ul">
              <Box component="li">The merchant of record (unless explicitly stated)</Box>
              <Box component="li">A partner in your business</Box>
              <Box component="li">Responsible for your student relationships</Box>
              <Box component="li">Responsible for guaranteeing outcomes</Box>
            </Box>
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            2. Independent Business Relationship
          </Typography>
          <Typography>
           You acknowledge that:
           <Box component="ul">
              <Box component="li">You are an independent business operator</Box>
              <Box component="li">Nothing in these Terms creates a partnership, joint venture, agency, or employment relationship </Box>
              <Box component="li">You have no authority to bind OceSha</Box>
            </Box>
            You are solely responsible for your business operations.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            3. Creator Responsibilities
          </Typography>
          <Typography>
           As a Creator, you are solely responsible for:
           <Box component="ul">
              <Box component="li">Accuracy of course content</Box>
              <Box component="li">Regulatory compliance</Box>
              <Box component="li">Licensing requirements</Box>
              <Box component="li">Professional credentials (if applicable)</Box>
              <Box component="li">Tax compliance</Box>
              <Box component="li">Consumer protection compliance</Box>
              <Box component="li">Advertising claims</Box>
              <Box component="li">Refund handling</Box>
            </Box>
            You must ensure that:
            <Box component="ul">
              <Box component="li">Your course descriptions are truthful</Box>
              <Box component="li">You do not make deceptive or exaggerated claims</Box>
              <Box component="li">You clearly disclose AI-generated components where appropriate</Box>
            </Box>
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            4. Digital Twin Monetization Disclosure
          </Typography>
          <Typography>
           If you use Digital Twin technology in paid courses: <br />
           You agree to:
              <Box component="ul">
              <Box component="li">Avoid misrepresentation of AI-generated instruction as live human interaction</Box>
              <Box component="li">Avoid false credential simulation</Box>
              <Box component="li">Avoid impersonating third parties</Box>
              <Box component="li">Avoid deceptive marketing practices</Box>
            </Box>
            OceSha may require disclosure language stating that certain instructional elements are AI-assisted.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            5. Revenue & Payouts
          </Typography>
          <Typography>
           All revenue generated through your courses:
           <Box component="ul">
              <Box component="li">Is processed through third-party payment providers</Box>
              <Box component="li">Is subject to their terms</Box>
              <Box component="li">Is subject to chargebacks and disputes</Box>
            </Box>
            OceSha is not liable for:
            <Box component="ul">
              <Box component="li">Payment disputes</Box>
              <Box component="li">Refund disputes</Box>
              <Box component="li">Fraudulent transactions</Box>
              <Box component="li">Frozen funds</Box>
              <Box component="li">Tax withholding</Box>
            </Box>
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            6. Refunds & Customer Disputes
          </Typography>
          <Typography>
           You are responsible for:
           <Box component="ul">
              <Box component="li">Establishing refund policies</Box>
              <Box component="li">Responding to refund requests</Box>
              <Box component="li">Managing student complaints</Box>
              <Box component="li">Handling chargebacks</Box>
            </Box>
            OceSha may, at its discretion:
            <Box component="ul">
              <Box component="li">Temporarily suspend monetization privileges</Box>
              <Box component="li">Remove a course listing</Box>
              <Box component="li">Require policy adjustments</Box>
            </Box>           
          if repeated complaints or disputes occur.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            7. Marketplace Visibility (If Applicable)
          </Typography>
          <Typography>
           If OceSha lists your course in a public directory or marketplace:
           <Box component="ul">
              <Box component="li">Listing placement is not guaranteed</Box>
              <Box component="li">Visibility is not guaranteed</Box>
              <Box component="li">Removal may occur if policy violations are detected</Box>
            </Box>
            OceSha reserves full discretion over marketplace curation.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            8. Prohibited Monetization Activities
          </Typography>
          <Typography>
           You may not sell or promote:
           <Box component="ul">
              <Box component="li">Illegal products or services</Box>
              <Box component="li">Fraudulent schemes</Box>
              <Box component="li">Unlicensed financial advice</Box>
              <Box component="li">Unlicensed medical advice</Box>
              <Box component="li">Securities or investment schemes</Box>
              <Box component="li">High-risk or prohibited categories</Box>
              <Box component="li">sleading AI-generated services</Box>
            </Box>
           OceSha may immediately disable monetization privileges upon detection.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            9. Compliance With Laws
          </Typography>
          <Typography>
           You agree to comply with:
           <Box component="ul">
              <Box component="li">Consumer protection laws</Box>
              <Box component="li">Advertising laws</Box>
              <Box component="li">Data protection laws</Box>
              <Box component="li">Tax laws</Box>
              <Box component="li">Professional licensing laws</Box>
              <Box component="li">International trade laws (if applicable)</Box>
            </Box>
            OceSha does not provide legal or compliance advice.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            10. Content Liability
          </Typography>
          <Typography>
           You retain full responsibility for:
           <Box component="ul">
              <Box component="li">Intellectual property infringement</Box>
              <Box component="li">Defamation claims</Box>
              <Box component="li">Misrepresentation claims</Box>
              <Box component="li">Professional negligence claims</Box>
            </Box>
           You agree to indemnify OceSha against claims arising from your monetized content.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            11. Suspension or Termination of Monetization
          </Typography>
          <Typography>
           OceSha may suspend or revoke monetization access if:
           <Box component="ul">
              <Box component="li">Excessive chargebacks occur</Box>
              <Box component="li">Fraud risk is identified</Box>
              <Box component="li">AI misuse is detected</Box>
              <Box component="li">Regulatory risk is present</Box>
              <Box component="li">Reputational harm risk exists</Box>
            </Box>
           We may act without notice if required for risk mitigation.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            12. No Revenue Guarantees
          </Typography>
          <Typography>
           OceSha does not guarantee:
           <Box component="ul">
              <Box component="li">Sales volume</Box>
              <Box component="li">Revenue</Box>
              <Box component="li">Traffic</Box>
              <Box component="li">Student conversion</Box>
              <Box component="li">Business success</Box>
            </Box>
           You acknowledge that monetization outcomes depend solely on your content, pricing, positioning, and market conditions.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            13. Platform Evolution
          </Typography>
          <Typography>
           OceSha may:
           <Box component="ul">
              <Box component="li">Introduce revenue-sharing models</Box>
              <Box component="li">Introduce marketplace fees</Box>
              <Box component="li">Modify monetization structures</Box>
            </Box>
           with notice. <br />
           Continued use constitutes acceptance.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            14. Indemnification
          </Typography>
          <Typography>
           You agree to indemnify and hold harmless OceSha from any claims arising from:
           <Box component="ul">
              <Box component="li">Your course content</Box>
              <Box component="li">Your Digital Twin usage</Box>
              <Box component="li">Your revenue activities</Box>
              <Box component="li">Student disputes</Box>
              <Box component="li">Regulatory violations</Box>
            </Box>
          </Typography>
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            15. Relationship to Other Agreements
          </Typography>
          <Typography>
           These Creator Terms operate alongside:
           <Box component="ul">
              <Box component="li">Terms of Service</Box>
              <Box component="li">AI Acceptable Use Addendum</Box>
              <Box component="li">Payment Processing Addendum</Box>
            </Box>
           In case of conflict, stricter provisions apply.
          </Typography>
          <Link
            to="/signin"
            style={{
              display: "flex",
              marginTop: 40,
              textDecoration: "none",
              color: "white",
            }}
          >
            <SvgIcon sx={{ mr: 1 }}>
              <KeyboardBackspace />
            </SvgIcon>
            Back to log in
          </Link>
        </Box>
      </Container>
    </>
  );
};

export default Creatormonetization;
